import { Image } from '@yleisradio/areena-types';
import { cloudinaryHostname } from '../environment';

const root = `https://${cloudinaryHostname}/image/upload/`;

const imgIdVersionPath = (image: Image): string =>
  `${image.version ? `/v${image.version}` : ''}/${image.id}`;

const defaultOptions = {
  aspect_ratio: 16 / 9,
  quality: 'auto',
  fetch_format: 'jpg',
};

type AssetOptions = {
  format?: string;
  width?: number;
  height?: number;
  blur?: number;
  fit?: boolean;
  aspectRatio?: number;
  quality?: string;
};

export const getAssetUrl = (
  image: Image,
  {
    format = defaultOptions.fetch_format,
    width,
    height,
    blur: blurStrength,
    fit,
    aspectRatio,
    quality = defaultOptions.quality,
  }: AssetOptions
) => {
  const clQuality = format === 'jpg' ? `q_${quality}/` : ``;
  const clFormat = `f_${format || 'auto'}/`;

  const clWidth = width
    ? width
    : height && aspectRatio
      ? Math.floor(height * aspectRatio)
      : undefined;

  const chainedParams = [
    `c_${fit ? 'fit' : 'fill'}`,
    height ? `h_${height}` : undefined,
    clWidth ? `w_${clWidth}` : undefined,
    blurStrength ? `e_blur:${blurStrength}` : undefined,
  ]
    .filter(p => !!p)
    .join(',');
  return `${root}${clQuality}${clFormat}${chainedParams}${imgIdVersionPath(image)}`;
};
